'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _OpeningCollection = require('../models/OpeningCollection');

var _OpeningCollection2 = _interopRequireDefault(_OpeningCollection);

var _dateUtils = require('../utils/dateUtils');

var _openingUtils = require('../utils/openingUtils');

var _reactUtils = require('../utils/reactUtils');

var _Carousel = require('./Carousel');

var _Carousel2 = _interopRequireDefault(_Carousel);

var _CalendarTable = require('./CalendarTable');

var _CalendarTable2 = _interopRequireDefault(_CalendarTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WEEKDAYS_ONLY = 'WEEKDAYS_ONLY';
var WEEKDAYS_AND_WEEKEND = 'WEEKDAYS_AND_WEEKEND';
var AUTO_DETECT_WEEKEND = 'AUTO_DETECT_WEEKEND';

var OpeningsCalendar = function (_Component) {
  _inherits(OpeningsCalendar, _Component);

  function OpeningsCalendar(props) {
    _classCallCheck(this, OpeningsCalendar);

    var _this = _possibleConstructorReturn(this, (OpeningsCalendar.__proto__ || Object.getPrototypeOf(OpeningsCalendar)).call(this, props));

    _this.onPreviousClick = function () {
      var onPreviousClick = _this.props.onPreviousClick;

      if (!_this._isPreviousDisabled() && onPreviousClick) {
        onPreviousClick();
      }
    };

    _this.onNextClick = function () {
      var onNextClick = _this.props.onNextClick;

      if (!_this._isNextDisabled() && onNextClick) {
        onNextClick();
      }
    };

    _this.onNextAvailableClick = function () {
      var onNextAvailableClick = _this.props.onNextAvailableClick;

      if (onNextAvailableClick) {
        onNextAvailableClick();
      }
    };

    _this.onAnimationStart = function () {
      _this.setState({ isAnimating: true });
    };

    _this.onAnimationEnd = function () {
      _this.setState({ isAnimating: false });
    };

    _this.state = { direction: 0, isAnimating: false };
    return _this;
  }

  _createClass(OpeningsCalendar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var direction = nextProps.selectedDate.diff(this.props.selectedDate);
      this.setState({ direction: direction });
    }
  }, {
    key: '_shouldIncludeWeekend',
    value: function _shouldIncludeWeekend(calendarType, openings) {
      if (calendarType === AUTO_DETECT_WEEKEND && openings && openings.length) {
        return (0, _openingUtils.containsWeekendOpenings)(openings);
      }
      return calendarType === WEEKDAYS_AND_WEEKEND;
    }
  }, {
    key: '_getDatesForWeek',
    value: function _getDatesForWeek(startDate, includeWeekend) {
      return (0, _dateUtils.getDateRange)(startDate, (0, _momentTimezone2.default)(startDate).add({ day: 6 }), {
        includeWeekend: includeWeekend
      });
    }
  }, {
    key: '_isPreviousDisabled',
    value: function _isPreviousDisabled() {
      var _props = this.props,
          isLoading = _props.isLoading,
          disablePrevious = _props.disablePrevious,
          onPreviousClick = _props.onPreviousClick;

      return this.state.isAnimating || isLoading || disablePrevious || onPreviousClick == null;
    }
  }, {
    key: '_isNextDisabled',
    value: function _isNextDisabled() {
      var _props2 = this.props,
          isLoading = _props2.isLoading,
          disableNext = _props2.disableNext,
          onNextClick = _props2.onNextClick;

      return this.state.isAnimating || isLoading || disableNext || onNextClick == null;
    }
  }, {
    key: '_renderNav',
    value: function _renderNav() {
      return [this._renderNavItem('previous', this.onPreviousClick, this._isPreviousDisabled(), [_react2.default.createElement('i', { key: 'icon', className: 'icon-angle-left' }), _react2.default.createElement(
        'span',
        { key: 'text' },
        'Previous'
      )]), this._renderNavItem('next', this.onNextClick, this._isNextDisabled(), [_react2.default.createElement('i', { key: 'icon', className: 'icon-angle-right' }), _react2.default.createElement(
        'span',
        { key: 'text' },
        'Next'
      )])];
    }
  }, {
    key: '_renderNavItem',
    value: function _renderNavItem(direction, onClick, isDisabled, content) {
      var className = 'openings-calendar__' + direction + ' icon-replace';
      if (isDisabled) {
        className += ' is-disabled';
        return _react2.default.createElement(
          'span',
          { key: direction, className: className },
          content
        );
      }
      return _react2.default.createElement(
        'a',
        { key: direction, href: 'javascript:void(0);', className: className, onClick: onClick },
        content
      );
    }
  }, {
    key: '_renderCalendarTable',
    value: function _renderCalendarTable() {
      var _props3 = this.props,
          openings = _props3.openings,
          calendarType = _props3.calendarType,
          selectedDate = _props3.selectedDate,
          props = _objectWithoutProperties(_props3, ['openings', 'calendarType', 'selectedDate']);

      var includeWeekend = this._shouldIncludeWeekend(calendarType, openings);
      var dates = this._getDatesForWeek(selectedDate, includeWeekend);
      var openingsCollection = new _OpeningCollection2.default(openings);
      var openingsForWeek = openingsCollection.filterByDates(dates);
      var selectedDateKey = selectedDate.format('YYYYMMDD');
      return _react2.default.createElement(
        _Carousel2.default,
        {
          key: 'carousel',
          direction: this.state.direction,
          onAnimationStart: this.onAnimationStart,
          onAnimationEnd: this.onAnimationEnd
        },
        _react2.default.createElement(_CalendarTable2.default, Object.assign({
          key: selectedDateKey,
          openings: openingsForWeek,
          onNextAvailableClick: this.onNextAvailableClick,
          dates: dates
        }, props))
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _renderNav2 = this._renderNav(),
          _renderNav3 = _slicedToArray(_renderNav2, 2),
          prev = _renderNav3[0],
          next = _renderNav3[1];

      return _react2.default.createElement(
        'div',
        { className: 'openings-calendar' },
        prev,
        next,
        this._renderCalendarTable()
      );
    }
  }]);

  return OpeningsCalendar;
}(_react.Component);

OpeningsCalendar.WEEKDAYS_ONLY = WEEKDAYS_ONLY;
OpeningsCalendar.WEEKDAYS_AND_WEEKEND = WEEKDAYS_AND_WEEKEND;
OpeningsCalendar.AUTO_DETECT_WEEKEND = AUTO_DETECT_WEEKEND;
OpeningsCalendar.propTypes = {
  isLoading: _propTypes2.default.bool,
  openings: _propTypes2.default.arrayOf(_reactUtils.openingShape),
  selectedDate: _reactUtils.momentShape,
  nextAvailableDate: _reactUtils.momentShape,
  timeInterval: _propTypes2.default.number,
  phoneNumber: _propTypes2.default.string,
  openingTarget: _propTypes2.default.string,
  calendarType: _propTypes2.default.oneOf([WEEKDAYS_ONLY, WEEKDAYS_AND_WEEKEND, AUTO_DETECT_WEEKEND]),
  onPreviousClick: _propTypes2.default.func,
  onNextClick: _propTypes2.default.func,
  onNextAvailableClick: _propTypes2.default.func,
  onOpeningClick: _propTypes2.default.func,
  disablePrevious: _propTypes2.default.bool,
  disableNext: _propTypes2.default.bool,
  renderHeaderDate: _propTypes2.default.func,
  renderRowTime: _propTypes2.default.func,
  renderOpening: _propTypes2.default.func
};
OpeningsCalendar.defaultProps = {
  isLoading: false,
  openings: [],
  selectedDate: (0, _momentTimezone2.default)(),
  index: 0,
  timeInterval: 30,
  calendarType: WEEKDAYS_ONLY,
  disablePrevious: false,
  disableNext: false
};
exports.default = OpeningsCalendar;